import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { IconTheme } from '@frk/eds-components';
import { TranslateService } from '@shared/translate/translate.service';
import { RatingsCellData } from '@types';
import { Logger } from '@utils/logger';
import { parseNumber } from '@utils/text/number-utils';
import get from 'lodash/get';

const logger = Logger.getLogger('RatingsCellRendererComponent');

@Component({
  selector: 'ft-ratings-cell-renderer',
  templateUrl: './ratings-cell-renderer.component.html',
  styleUrls: ['./ratings-cell-renderer.component.scss'],
})
export class RatingsCellRendererComponent {
  public rating: number;
  public isHybrid: boolean;
  public numberOfFunds: string;
  public showNumberOfFunds: boolean;
  public showStarLabels: boolean;
  public starLabel: string;
  public theme: IconTheme;

  constructor(private translateService: TranslateService) {}

  agInit(params: ICellRendererParams) {
    const ratingsCellData: RatingsCellData = params.column.getColDef()
      .cellRendererParams;
    const ratings = get(params.data, ratingsCellData.ratingsPath, '0');
    this.rating = parseNumber(ratings);
    this.isHybrid = get(params.data, ratingsCellData.hybridPath, false);
    this.theme = ratingsCellData.theme || 'default';
    this.numberOfFunds = get(
      params.data,
      ratingsCellData.numberOfFundsPath,
      null
    );
    this.showNumberOfFunds =
      this.numberOfFunds && !ratingsCellData.hideNumberOfFunds;
    this.showStarLabels = ratingsCellData.showStarLabels;
    this.starLabel = this.translateService.instant(
      `products.rating_${this.rating}-star`
    );
  }
}
